import React from "react";
import { useDatadogAwsConsolelogin } from "@/hooks/useDatadogAwsConsole";

const DatadogDashboard = () => {
  const { embedUrl } = useDatadogAwsConsolelogin();

  return (
    <div className="datadog-container">
      <iframe
        title="Datadog Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default DatadogDashboard;